import { createStyles, rem } from '@mantine/core'

type StylesParams = {
  type: 'input' | 'button'
}

export default createStyles((theme, { type }: StylesParams) => {
  return {
    root: {},
    heading: {},
    input: {},
    inputWrapper: {},
    inputRightSection: {
      width: 'auto',
    },
    btn: {
      padding: rem(8),
      '&:active': {
        transform: 'translateY(0)',
      },
      ...(type === 'input'
        ? {
            paddingLeft: '1.5rem',
            borderColor: 'transparent',
            borderTopRightRadius: '8px',
            borderBottomRightRadius: '8px',
            height: `${rem(38)} !important`,
            marginRight: '1px',
            '&,&:hover': {
              background: `linear-gradient(90deg, rgba(255, 255, 255, 0), white 20%)`,
              backgroundColor: 'transparent',
            },
          }
        : {
            padding: 0,
            borderRadius: rem(4),
            width: `${rem(32)}`,
            height: `${rem(32)}`,
            backgroundColor:
              type === 'button' ? '#fff' : `${theme.colors.gray[1]}`,
            '&.copied': {
              backgroundColor: `${theme.colors.gray[2]}`,
            },
          }),
    },

    btnLabel: {
      ...(type === 'button' && {
        display: 'none',
      }),
    },
    btnRoot: {},
    btnLeftIcon: {
      marginRight: 0,
    },
    popoverDropdown: {
      zIndex: 1,
      padding: rem(5),
      background: theme.colors.gray[6],
      textAlign: 'center',
      borderColor: theme.colors.gray[6],
    },
    popoverArrow: {
      borderColor: theme.colors.gray[6],
    },
  }
})
